export const FILTER_OPTIONS = [{ label: "Search by Name", value: "NAME" }, { label: "Search by Tax ID", value: "TAX_ID" }]